const STORAGE_KEY = 'journiy.admin.auth';

// The peer-environment admin token for image sync. It is a SECRET: it only
// ever lives in this browser's localStorage, is sent per-request in the
// X-Image-Sync-Peer-Token header, and is never stored server-side.
const PEER_TOKEN_KEY = 'journiy.admin.image-sync.peer-token';

export function loadStoredToken() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function storeToken(profile) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
}

export function clearStoredToken() {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function loadPeerToken() {
  try {
    return window.localStorage.getItem(PEER_TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function storePeerToken(token) {
  try {
    if (token && token.trim()) {
      window.localStorage.setItem(PEER_TOKEN_KEY, token.trim());
    } else {
      window.localStorage.removeItem(PEER_TOKEN_KEY);
    }
    // Same-tab notification (the 'storage' event only fires in other tabs).
    window.dispatchEvent(new Event('journiy:peer-token-changed'));
  } catch {
    // Private mode / storage unavailable: the token still works for the
    // current request flow if supplied each time, but cannot persist.
  }
}
